import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Guard: phone must be verified before accessing profile setup */
export const verifiedGuard: CanActivateFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  return auth.isVerified() ? true : router.createUrlTree(['/login']);
};

/** Guard: dashboard is only for verified users who already completed their profile */
export const profileCompleteGuard: CanActivateFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  return auth.isVerified() && auth.profileComplete() ? true : router.createUrlTree(['/login']);
};
